<div class="card">
  <div class="card-title title">{{ form?.value?.Name }}</div>

  <!--<ng-container *ngIf="!isModal() && !readonly">
    <button class="card-edit edit" (click)="handleNewBeneficiarioModal()">
      <app-svg-icon src="../../../../assets/icons/edit-icon.svg"
                    width="14px"
                    color="white">
      </app-svg-icon>
    </button>
    <button class="card-lixeira lixeira"
            (click)="removeItemBeneficiaryForm[cardType](index)">
      <app-svg-icon src="../../../../assets/icons/trash-icon.svg"
                    width="17px"
                    height="18px"
                    color="white">
      </app-svg-icon>
    </button>
  </ng-container>-->

  <form class="d-flex card-conteudo conteudo" [formGroup]="form">
    <ng-container *ngFor="let input of inputs; let i = index">
      <app-c-input *ngIf="input.controlName"
                   class="conteudo-cinput"
                   [label]="input.label"
                   [placeholder]="input.placeholder"
                   [formControlName]="input.controlName"
                   [readonly]="true"
                   [inputType]="input.type ?? ''"
                   [inputMask]="input.mask"
                   [currencyMask]="!!input.currency"
                   [index]="index">
      </app-c-input>
      <app-c-input *ngIf="!input.controlName"
                   class="conteudo-cinput"
                   [label]="input.label"
                   [placeholder]="input.placeholder"
                   [readonly]="true"
                   [inputType]="input.type ?? ''"
                   [currencyMask]="!!input.currency"
                   [index]="index">
      </app-c-input>
    </ng-container>
    <div style="margin: 0 15px;" *ngIf="hasChangedRate">
      <strong>Justificativa para a alteração da comissão</strong>&nbsp;
      <a href="javascript:void(0);" (click)="downloadAgreementDocument(this.changedCommission.ContractId,
         this.changedCommission.AgreementDocumentChangeCommission)">
        <img src="../../../../assets/icons/download-icon.svg" width="20" alt="Baixar documento" />
      </a>
      <div style="font-weight: normal; margin-top: 10px;">
        {{this.changedCommission.JustificationChangeCommission}} - 1
      </div>
    </div>
  </form>
</div>
